import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createLocation as universalCreateLocation, bulkCreateLocation as universalBulkCreateLocation, getLocation as universalGetLocation, listLocations as universalListLocations, updateLocation as universalUpdateLocation, bulkUpdateLocation as universalBulkUpdateLocation, queryLocations as universalQueryLocations, setDefaultLocation as universalSetDefaultLocation, archiveLocation as universalArchiveLocation, addLocationType as universalAddLocationType, removeLocationType as universalRemoveLocationType, } from './locations-v1-location.universal';
import { LocationStatus, LocationType, DayOfWeek, SortOrder, WebhookIdentityType, } from './locations-v1-location.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.locations.v1.location', module_name: 'wix-business-tools.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createLocation: (location) => {
            const methodLogData = {
                method_name: 'createLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.createLocation',
            };
            return universalCreateLocation(location, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkCreateLocation: (locations) => {
            const methodLogData = {
                method_name: 'bulkCreateLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.bulkCreateLocation',
            };
            return universalBulkCreateLocation(locations, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getLocation: (_id) => {
            const methodLogData = {
                method_name: 'getLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.getLocation',
            };
            return universalGetLocation(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listLocations: (options) => {
            const methodLogData = {
                method_name: 'listLocations',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.listLocations',
            };
            return universalListLocations(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateLocation: (_id, location) => {
            const methodLogData = {
                method_name: 'updateLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.updateLocation',
            };
            return universalUpdateLocation(_id, location, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateLocation: (locations) => {
            const methodLogData = {
                method_name: 'bulkUpdateLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.bulkUpdateLocation',
            };
            return universalBulkUpdateLocation(locations, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryLocations: () => {
            const methodLogData = {
                method_name: 'queryLocations',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.queryLocations',
            };
            return universalQueryLocations(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setDefaultLocation: (_id) => {
            const methodLogData = {
                method_name: 'setDefaultLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.setDefaultLocation',
            };
            return universalSetDefaultLocation(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        archiveLocation: (_id) => {
            const methodLogData = {
                method_name: 'archiveLocation',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.archiveLocation',
            };
            return universalArchiveLocation(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addLocationType: (_id, locationType) => {
            const methodLogData = {
                method_name: 'addLocationType',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.addLocationType',
            };
            return universalAddLocationType(_id, locationType, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeLocationType: (_id, locationType) => {
            const methodLogData = {
                method_name: 'removeLocationType',
                service_name: 'com.wixpress.locations.LocationsService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-business-tools.v2,entity=wix.locations.v1.location,environment=velo-frontend,method-fqn=com.wixpress.locations.LocationsService.removeLocationType',
            };
            return universalRemoveLocationType(_id, locationType, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        LocationStatus,
        LocationType,
        DayOfWeek,
        SortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=locations-v1-location.frontend.js.map